module.exports = new __parcel__URL__("return.44414c16.svg").toString();